exports.connect = {
	url: "https://api.campinglozere.camp/"
}
